<script setup lang="ts">
import {useSeoStore} from "~/stores/useSeoStore";
import IconFaqCommon from "~/components/sx/icons/faq/IconFaqCommon.vue";
import IconFaqPayment from "~/components/sx/icons/faq/IconFaqPayment.vue";
import IconFaqTerms from "~/components/sx/icons/faq/IconFaqTerms.vue";
import IconFaqSupport from "~/components/sx/icons/faq/IconFaqSupport.vue";
import IconFaqExtra from "~/components/sx/icons/faq/IconFaqExtra.vue";

const { getTitleFAQ, getDescriptionFAQ } = useSeoStore();
const { t } = useLocale();

definePageMeta({
  layout: 'custom'
})

useSeoMeta({
  ogTitle: getTitleFAQ(),
  ogDescription: getDescriptionFAQ(),
  twitterCard: 'summary_large_image',
});

useHead({
  title: getTitleFAQ(),
  meta: [
    { name: 'description', content: getDescriptionFAQ() }
  ],
});

definePageMeta({
  middleware: ['i18n-links'],
});

const items = [
  {
    logo: markRaw(IconFaqCommon),
    id: 1,
    title: 'Общее о SX.ORG',
    description: 'SX.ORG — это умная прокси-биржа нового поколения. Мы объединили  свой пул и десятки поставщиков IP по всему миру и создали удобную платформу, где вы получаете стабильный, анонимный и быстро работающий IP-адрес в пару кликов.',
  },
  {
    logo: markRaw(IconFaqPayment),
    id: 2,
    title: 'Оплата и тарифы',
    description: 'Поддержка SX.ORG работает 24/7 — мы всегда на связи, чтобы помочь с настройкой, подбором прокси или любым другим вопросом. Связаться с нами можно через тикет на сайте, Telegram-бота, WeChat или по email — ответим вам в течение 10 минут.',
  },
  {
    logo: markRaw(IconFaqTerms),
    id: 3,
    title: 'Условия использования и безопасность',
    description: 'SX.ORG — это умная прокси-биржа нового поколения. Мы объединили  свой пул и десятки поставщиков IP по всему миру и создали удобную платформу, где вы получаете стабильный, анонимный и быстро работающий IP-адрес в пару кликов.',
  },
  {
    logo: markRaw(IconFaqSupport),
    id: 4,
    title: 'Поддержка и помощь',
    description: 'Поддержка SX.ORG работает 24/7 — мы всегда на связи, чтобы помочь с настройкой, подбором прокси или любым другим вопросом. Связаться с нами можно через тикет на сайте, Telegram-бота, WeChat или по email — ответим вам в течение 10 минут. Поддержка SX.ORG работает 24/7 — мы всегда на связи, чтобы помочь с настройкой, подбором прокси или любым другим вопросом. Связаться с нами можно через тикет на сайте, Telegram-бота, WeChat или по email — ответим вам в течение 10 минут.',
  },
  {
    logo: markRaw(IconFaqExtra),
    id: 5,
    title: 'Прочее о прокси',
    description: 'SX.ORG — это умная прокси-биржа нового поколения. Мы объединили  свой пул и десятки поставщиков IP по всему миру и создали удобную платформу, где вы получаете стабильный, анонимный и быстро работающий IP-адрес в пару кликов.',
  },
];
</script>

<template>
  <div class="faq">
    <h1 class="sx-landing-title">
      {{ t('Часто задаваемые вопросы') }}
    </h1>
    <div class="faq__content">
      <FaqArticle
        v-for="(item, index) in items"
        :key="index"
        :item="item"
      />
    </div>
  </div>
</template>